import React from "react";
import { hydrateRoot, createRoot } from "react-dom/client";
import axios from "axios";
import "@/index.css";
import App from "@/App";

// Set global security header for all API calls
axios.defaults.headers.common['X-Frontend-Id'] = 'EastendIron-Secured-v1';

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
